import { downloadPlaceholder, placeholderUrl, preloadPlaceholder } from './util/single_image_helpers'
import { bindings } from '../'

/**
 *  Downloads all the placeholder images whose slide server URLs are given
 *
 * @param {string[]} slideServerUrls An array of slide server URLs
 * @return {Promise<string[]>} A Promise resolved with an array of
 *   strings. Each entry is either the base 64 encoded image data of the image
 *   (if download succeeded) or an empty string (if download failed).
 */
export async function downloadPlaceholders (slideServerUrls = []) {
  if (!slideServerUrls.length) {
    throw new Error('Downloading placeholders failed. Slide urls are missing.')
  }

  let progress = 0
  return Promise.all(slideServerUrls.map(url => {
    const promise = downloadPlaceholder(url)
    promise.then(() => {
      ++progress
      bindings.publishEvent(bindings.operationProgressEvent, 'downloadPlaceholders', { code: 'INSERT_IMAGES_DOWNLOADING', progress, total: slideServerUrls.length })
    })

    return promise
  }))
}

export async function preloadPlaceholders (slideServerUrls = []) {
  if (!slideServerUrls.length) {
    throw new Error('Preloading placeholders failed. Slide urls are missing.')
  }
  return Promise.all(slideServerUrls.map(preloadPlaceholder))
}

/**
 *  Gets placeholder URLs for images whose slide server URLs are given
 *
 * @param {string[]} slideServerUrls An array of slide server URLs
 * @return {Promise<string[]>} A Promise resolved with an array of
 *   strings. Each entry is either the URL of the placeholder image
 *   (if the lookup succeeded) or an empty string (if the lookup failed).
 */
export async function placeholderUrls (slideServerUrls = []) {
  if (!slideServerUrls.length) {
    throw new Error('Retrieving placeholder urls failed. Slide urls are missing.')
  }

  let progress = 0
  return Promise.all(slideServerUrls.map(url => {
    const promise = placeholderUrl(url)
    promise.then(() => {
      ++progress
      bindings.publishEvent(bindings.operationProgressEvent, 'placeholderUrls', { code: 'INSERT_IMAGES_DOWNLOADING', progress, total: slideServerUrls.length })
    })

    return promise
  }))
}
